import axiosInstance from './interceptor'

//get lab locations for bottle order
export const getASMUser = async () => {

    return await axiosInstance.get(`User/GetASMUsers`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const externalQuoteBottleOrderCartApi = async (payload: any) => {

    return await axiosInstance.post(`BottleOrder/AddToCheckoutForCustomers`, payload).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}